export  class BaseEntity {

inserted  : boolean = false;
updated   : boolean = false;
deleted   : boolean = false;


edit      : boolean = false;
expand    : boolean = false;
selected       :boolean = false;

_original    : any;

}


/*

protected static getDate(d: any): Date {
    if (d == null) {
        return null;
    }
    return new Date(d);
}

*/